import { render, staticRenderFns } from "./controlRangeDetail.vue?vue&type=template&id=4da80b56&scoped=true"
import script from "./controlRangeDetail.vue?vue&type=script&lang=js"
export * from "./controlRangeDetail.vue?vue&type=script&lang=js"
import style0 from "./controlRangeDetail.vue?vue&type=style&index=0&id=4da80b56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da80b56",
  null
  
)

export default component.exports